import script from "./NavigationDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationDesktop.vue?vue&type=script&setup=true&lang=js"

import "./NavigationDesktop.vue?vue&type=style&index=0&id=3d3dc5e0&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d3dc5e0"]])

export default __exports__